import RESTModelNormalizationSchemas from '../../redux/models/RESTModelNormalizationSchemas'

export const coerceIoActivated = value => {
  if (value === true || value === 1) return true
  if (value === false || value === 0) return false
  if (typeof value === 'string') {
    const lowered = value.trim().toLowerCase()
    if (lowered === 'true' || lowered === '1') return true
    if (lowered === 'false' || lowered === '0') return false
  }
  return !!value
}

export const extractTrackerIoPayload = payload => {
  if (!payload || typeof payload !== 'object') {
    return { inputs: null, outputs: null }
  }

  const inputs = Array.isArray(payload.inputs)
    ? payload.inputs
    : Array.isArray(payload.device?.inputs)
      ? payload.device.inputs
      : null
  const outputs = Array.isArray(payload.outputs)
    ? payload.outputs
    : Array.isArray(payload.device?.outputs)
      ? payload.device.outputs
      : null

  return { inputs, outputs }
}

const mergeIoSlice = (existingStore, rows) => {
  if (!Array.isArray(rows) || !rows.length || !existingStore) {
    return null
  }

  const map = {}
  for (const row of rows) {
    const id = row?.id != null ? String(row.id) : null
    if (!id) continue
    const existing = existingStore[id]
    if (!existing) continue
    map[id] = {
      ...existing,
      activated: coerceIoActivated(row.activated)
    }
  }

  return Object.keys(map).length ? map : null
}

/**
 * Builds a mergeEntitiesIntoStores payload that patches deviceInputs / deviceOutputs
 * `activated` from an additive tracker-refresh socket payload.
 * Skips ids that are not already in the store so partial rows cannot wipe model links.
 */
export const buildTrackerIoMergeEntities = (dataState, payload) => {
  if (!dataState) return null

  const { inputs, outputs } = extractTrackerIoPayload(payload)
  const entities = {}

  const inputMap = mergeIoSlice(dataState.deviceInputs, inputs)
  if (inputMap) {
    entities[RESTModelNormalizationSchemas.deviceInput.entityName] = inputMap
  }

  const outputMap = mergeIoSlice(dataState.deviceOutputs, outputs)
  if (outputMap) {
    entities[RESTModelNormalizationSchemas.deviceOutput.entityName] = outputMap
  }

  return Object.keys(entities).length ? entities : null
}
